import { AnswerCategory } from "@/schema/console/checking-assessments/AnswerCategory";
import CategoryTable from "@/src/console/(auth)/_components/CheckingAssessment/CategoriesSection/CategoryTable";
import { AppsListRegular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

interface CategoriesSectionProps {
  data: AnswerCategory[];
}

const CategoriesSection = ({ data }: CategoriesSectionProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="text-2xl font-bold">{t("categories")}</div>
        <div className="flex gap-1 justify-start items-center">
          <AppsListRegular />
          <span>{data.length} {t("categories")}</span>
        </div>
      </div>
      <div className="mt-4">
        <CategoryTable data={data} />
      </div>
    </>
  );
};

export default CategoriesSection;
